// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   PAGE
========================= */
.adminPaiementPage {
  background: var(--white-principale);
  min-height: 100vh;
  padding: 12px 0 26px;
  font-family: Arial, sans-serif;
}

/* =========================
   GRID / CARD
========================= */
.adminPaiementGrid {
  display: flex;
  justify-content: center;
}

.adminPaiementCard {
  border-radius: 12px;
  background: var(--white-principale);
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.14);
  padding: 16px;
}

.adminPaiementCardCenter {
  width: 100%;
  max-width: 1500px;
  margin-top: 16px;
}

/* =========================
   HEADER
========================= */
.adminPaiementHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.adminPaiementTitle {
  font-weight: 900;
  font-size: 14px;
  color: var(--couleur-dark);
}

.adminPaiementSubtitle {
  margin-top: 4px;
  font-size: 12px;
  color: var(--gris-terciaire);
}

/* =========================
   BUTTONS
========================= */
.adminPaiementBtn {
  border: none;
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: filter 0.15s ease, opacity 0.15s ease;
}

.adminPaiementBtnSoft {
  background: rgba(0, 0, 0, 0.06);
  color: var(--couleur-dark);
}

.adminPaiementBtnSoft:hover {
  filter: brightness(0.96);
}

.adminPaiementBtn:disabled {
  opacity: 0.6;
  cursor: default;
}

/* =========================
   FILTERS
========================= */
.adminPaiementFilters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 0 14px;
}

.adminPaiementSearch {
  flex: 1 1 360px;
  min-width: 260px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 999px;
  padding: 8px 12px;
  background: var(--white-principale);
}

.adminPaiementSearch i {
  color: var(--gris-terciaire);
}

.adminPaiementSearch input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 12px;
  color: var(--couleur-dark);
  background: transparent;
}

.adminPaiementSelects {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.adminPaiementSelects select {
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

/* =========================
   TABLE
========================= */
.adminPaiementTableWrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
}

.adminPaiementTable {
  width: 100%;
  border-collapse: collapse;
  min-width: 980px;
}

.adminPaiementTable thead th {
  text-align: left;
  font-size: 11px;
  color: var(--gris-terciaire);
  font-weight: 900;
  padding: 12px;
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid var(--gris-secondaire-2);
}

.adminPaiementTable tbody td {
  padding: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 12px;
  color: var(--couleur-dark);
  vertical-align: middle;
}

.adminPaiementTable tbody tr:hover {
  background: rgba(0, 0, 0, 0.02);
}

.muted {
  color: var(--gris-terciaire);
}

/* =========================
   USER CELL
========================= */
.adminPaiementCellUser {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 240px;
}

.adminPaiementCellUserText {
  min-width: 0;
}

.adminPaiementName {
  font-weight: 900;
  font-size: 12px;
  color: var(--couleur-dark);
}

/* =========================
   BADGES
========================= */
.adminPaiementBadge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 14px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.02em;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin: 0;
  width: 116px;
  justify-content: center;
  text-align: center;
}

/* ============================================================
   STATUT PAIEMENT — BADGE CLIQUABLE + DROPDOWN
   ============================================================ */

.adminPaiementBadgeClickable {
  border: 1px solid rgba(0, 0, 0, 0.08);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  transition: filter 0.15s ease, transform 0.1s ease;
}

.adminPaiementBadgeClickable:hover {
  filter: brightness(0.94);
}

.adminPaiementBadgeClickable:active {
  transform: scale(0.97);
}

.adminPaiementBadgeClickable:disabled {
  cursor: default;
  opacity: 0.7;
}

.adminPaiementBadgeCaret {
  font-size: 9px;
  opacity: 0.7;
}

.adminPaiementStatusSpinner {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-top-color: currentColor;
  border-radius: 50%;
  display: inline-block;
  animation: adminPaiementSpin 0.6s linear infinite;
}

@keyframes adminPaiementSpin {
  to {
    transform: rotate(360deg);
  }
}

.adminPaiementStatusDropdown {
  position: fixed;
  z-index: 2000;
  background: var(--white-principale);
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
  padding: 6px;
  min-width: 170px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.adminPaiementStatusItem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  color: var(--couleur-dark);
  transition: background 0.12s ease;
}

.adminPaiementStatusItem:hover {
  background: rgba(0, 0, 0, 0.05);
}

.adminPaiementStatusItem.isCurrent {
  background: rgba(0, 0, 0, 0.04);
}

.adminPaiementStatusCheck {
  margin-left: auto;
  font-size: 13px;
}

.statusItemPaye i:first-child {
  color: #1cb45d;
}

.statusItemAttente i:first-child {
  color: #ffc107;
}

.statusItemEchoue i:first-child {
  color: #dc3545;
}

.statusItemGratuit i:first-child {
  color: var(--couleur-principale);
}

.badgeGratuit {
  background: rgba(11, 0, 207, 0.1);
  color: var(--couleur-principale);
}

.badgeActive {
  background: rgba(28, 180, 93, 0.12);
  color: #1cb45d;
}

.badgeSoft {
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
}

.badgeBlocked {
  background: rgba(220, 53, 69, 0.12);
  color: #dc3545;
}

.badgeArchived {
  background: rgba(0, 0, 0, 0.08);
}

.badgeNotArchived {
  background: rgba(0, 123, 255, 0.12);
  color: #0d6efd;
}

/* =========================
   ACTIONS
========================= */
.colActions {
  width: 110px;
}

.adminPaiementActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.adminPaiementIconBtn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: var(--white-principale);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.adminPaiementIconBtn:hover {
  filter: brightness(0.98);
}

/* =========================
   EMPTY / LOADER
========================= */
.adminPaiementEmpty {
  padding: 22px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: var(--gris-terciaire);
  text-align: center;
}

/* =========================
   PAGINATION
========================= */
.adminPaiementPagination {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

/* =========================
   RESPONSIVE
========================= */
.hideOnMobile {
  display: table-cell;
}

.adminPaiementMobileMeta {
  display: none;
}

.adminPaiementPagination .adminPaiementIconBtn {
  transition: filter .15s ease, transform .06s ease;
}

.adminPaiementPagination .adminPaiementIconBtn:active {
  transform: scale(.98);
}

.adminPaiementPagination .adminPaiementIconBtn:disabled {
  opacity: .55;
  cursor: default;
}


/* Filtre date periode */
.adminPaiementDateRange {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: end;
}

.adminPaiementDateField {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.adminPaiementDateLabel {
  font-size: 10px;
  font-weight: 800;
  color: var(--gris-terciaire);
}

.adminPaiementDateField input[type="date"] {
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

.badgeDiscount {
  background: rgba(11, 0, 207, 0.1);
  color: var(--couleur-principale);
}


@media (max-width: 720px) {
  .hideOnMobile {
    display: none !important;
  }

  .adminPaiementTable {
    min-width: 0;
  }

  .adminPaiementTable thead {
    display: none;
  }

  .adminPaiementTableWrap {
    border: none;
  }

  .adminPaiementTable tbody {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .adminPaiementTable tbody tr {
    display: block;
    border: 1px solid var(--gris-secondaire-2);
    border-radius: 14px;
    padding: 10px;
    background: var(--white-principale);
  }

  .adminPaiementTable tbody td {
    display: block;
    border-bottom: none;
    padding: 6px 4px;
  }

  .colActions {
    width: auto;
  }

  .adminPaiementActions {
    justify-content: flex-end;
    margin-top: 6px;
  }

  .adminPaiementMobileMeta {
    display: block;
    margin-top: 8px;
    font-size: 11px;
    color: var(--gris-terciaire);
    line-height: 1.35;
  }

  .adminPaiementMobileMeta div {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/admin/gestionPaiement/AdminPaiementsPage.css"],"names":[],"mappings":"AAAA;;2BAE2B;AAC3B;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA;;2BAE2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;2BAE2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;EACE,qCAAqC;EACrC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;2BAE2B;AAC3B;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;2BAE2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;2BAE2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;;AAGA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;;AAGA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mCAAmC;EACrC;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;AACF","sourcesContent":["/* =========================\n   PAGE\n========================= */\n.adminPaiementPage {\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 12px 0 26px;\n  font-family: Arial, sans-serif;\n}\n\n/* =========================\n   GRID / CARD\n========================= */\n.adminPaiementGrid {\n  display: flex;\n  justify-content: center;\n}\n\n.adminPaiementCard {\n  border-radius: 12px;\n  background: var(--white-principale);\n  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.14);\n  padding: 16px;\n}\n\n.adminPaiementCardCenter {\n  width: 100%;\n  max-width: 1500px;\n  margin-top: 16px;\n}\n\n/* =========================\n   HEADER\n========================= */\n.adminPaiementHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.adminPaiementTitle {\n  font-weight: 900;\n  font-size: 14px;\n  color: var(--couleur-dark);\n}\n\n.adminPaiementSubtitle {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n/* =========================\n   BUTTONS\n========================= */\n.adminPaiementBtn {\n  border: none;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: filter 0.15s ease, opacity 0.15s ease;\n}\n\n.adminPaiementBtnSoft {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--couleur-dark);\n}\n\n.adminPaiementBtnSoft:hover {\n  filter: brightness(0.96);\n}\n\n.adminPaiementBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* =========================\n   FILTERS\n========================= */\n.adminPaiementFilters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 12px 0 14px;\n}\n\n.adminPaiementSearch {\n  flex: 1 1 360px;\n  min-width: 260px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 999px;\n  padding: 8px 12px;\n  background: var(--white-principale);\n}\n\n.adminPaiementSearch i {\n  color: var(--gris-terciaire);\n}\n\n.adminPaiementSearch input {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: transparent;\n}\n\n.adminPaiementSelects {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.adminPaiementSelects select {\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n/* =========================\n   TABLE\n========================= */\n.adminPaiementTableWrap {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n}\n\n.adminPaiementTable {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 980px;\n}\n\n.adminPaiementTable thead th {\n  text-align: left;\n  font-size: 11px;\n  color: var(--gris-terciaire);\n  font-weight: 900;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid var(--gris-secondaire-2);\n}\n\n.adminPaiementTable tbody td {\n  padding: 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  font-size: 12px;\n  color: var(--couleur-dark);\n  vertical-align: middle;\n}\n\n.adminPaiementTable tbody tr:hover {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.muted {\n  color: var(--gris-terciaire);\n}\n\n/* =========================\n   USER CELL\n========================= */\n.adminPaiementCellUser {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 240px;\n}\n\n.adminPaiementCellUserText {\n  min-width: 0;\n}\n\n.adminPaiementName {\n  font-weight: 900;\n  font-size: 12px;\n  color: var(--couleur-dark);\n}\n\n/* =========================\n   BADGES\n========================= */\n.adminPaiementBadge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 14px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 900;\n  letter-spacing: 0.02em;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  margin: 0;\n  width: 116px;\n  justify-content: center;\n  text-align: center;\n}\n\n/* ============================================================\n   STATUT PAIEMENT — BADGE CLIQUABLE + DROPDOWN\n   ============================================================ */\n\n.adminPaiementBadgeClickable {\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: center;\n  transition: filter 0.15s ease, transform 0.1s ease;\n}\n\n.adminPaiementBadgeClickable:hover {\n  filter: brightness(0.94);\n}\n\n.adminPaiementBadgeClickable:active {\n  transform: scale(0.97);\n}\n\n.adminPaiementBadgeClickable:disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n\n.adminPaiementBadgeCaret {\n  font-size: 9px;\n  opacity: 0.7;\n}\n\n.adminPaiementStatusSpinner {\n  width: 12px;\n  height: 12px;\n  border: 2px solid rgba(0, 0, 0, 0.15);\n  border-top-color: currentColor;\n  border-radius: 50%;\n  display: inline-block;\n  animation: adminPaiementSpin 0.6s linear infinite;\n}\n\n@keyframes adminPaiementSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.adminPaiementStatusDropdown {\n  position: fixed;\n  z-index: 2000;\n  background: var(--white-principale);\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);\n  padding: 6px;\n  min-width: 170px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.adminPaiementStatusItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 10px;\n  border-radius: 8px;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  color: var(--couleur-dark);\n  transition: background 0.12s ease;\n}\n\n.adminPaiementStatusItem:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.adminPaiementStatusItem.isCurrent {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.adminPaiementStatusCheck {\n  margin-left: auto;\n  font-size: 13px;\n}\n\n.statusItemPaye i:first-child {\n  color: #1cb45d;\n}\n\n.statusItemAttente i:first-child {\n  color: #ffc107;\n}\n\n.statusItemEchoue i:first-child {\n  color: #dc3545;\n}\n\n.statusItemGratuit i:first-child {\n  color: var(--couleur-principale);\n}\n\n.badgeGratuit {\n  background: rgba(11, 0, 207, 0.1);\n  color: var(--couleur-principale);\n}\n\n.badgeActive {\n  background: rgba(28, 180, 93, 0.12);\n  color: #1cb45d;\n}\n\n.badgeSoft {\n  background: rgba(255, 193, 7, 0.15);\n  color: #ffc107;\n}\n\n.badgeBlocked {\n  background: rgba(220, 53, 69, 0.12);\n  color: #dc3545;\n}\n\n.badgeArchived {\n  background: rgba(0, 0, 0, 0.08);\n}\n\n.badgeNotArchived {\n  background: rgba(0, 123, 255, 0.12);\n  color: #0d6efd;\n}\n\n/* =========================\n   ACTIONS\n========================= */\n.colActions {\n  width: 110px;\n}\n\n.adminPaiementActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.adminPaiementIconBtn {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: var(--white-principale);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.adminPaiementIconBtn:hover {\n  filter: brightness(0.98);\n}\n\n/* =========================\n   EMPTY / LOADER\n========================= */\n.adminPaiementEmpty {\n  padding: 22px 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  color: var(--gris-terciaire);\n  text-align: center;\n}\n\n/* =========================\n   PAGINATION\n========================= */\n.adminPaiementPagination {\n  margin-top: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n/* =========================\n   RESPONSIVE\n========================= */\n.hideOnMobile {\n  display: table-cell;\n}\n\n.adminPaiementMobileMeta {\n  display: none;\n}\n\n.adminPaiementPagination .adminPaiementIconBtn {\n  transition: filter .15s ease, transform .06s ease;\n}\n\n.adminPaiementPagination .adminPaiementIconBtn:active {\n  transform: scale(.98);\n}\n\n.adminPaiementPagination .adminPaiementIconBtn:disabled {\n  opacity: .55;\n  cursor: default;\n}\n\n\n/* Filtre date periode */\n.adminPaiementDateRange {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: end;\n}\n\n.adminPaiementDateField {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.adminPaiementDateLabel {\n  font-size: 10px;\n  font-weight: 800;\n  color: var(--gris-terciaire);\n}\n\n.adminPaiementDateField input[type=\"date\"] {\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n.badgeDiscount {\n  background: rgba(11, 0, 207, 0.1);\n  color: var(--couleur-principale);\n}\n\n\n@media (max-width: 720px) {\n  .hideOnMobile {\n    display: none !important;\n  }\n\n  .adminPaiementTable {\n    min-width: 0;\n  }\n\n  .adminPaiementTable thead {\n    display: none;\n  }\n\n  .adminPaiementTableWrap {\n    border: none;\n  }\n\n  .adminPaiementTable tbody {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .adminPaiementTable tbody tr {\n    display: block;\n    border: 1px solid var(--gris-secondaire-2);\n    border-radius: 14px;\n    padding: 10px;\n    background: var(--white-principale);\n  }\n\n  .adminPaiementTable tbody td {\n    display: block;\n    border-bottom: none;\n    padding: 6px 4px;\n  }\n\n  .colActions {\n    width: auto;\n  }\n\n  .adminPaiementActions {\n    justify-content: flex-end;\n    margin-top: 6px;\n  }\n\n  .adminPaiementMobileMeta {\n    display: block;\n    margin-top: 8px;\n    font-size: 11px;\n    color: var(--gris-terciaire);\n    line-height: 1.35;\n  }\n\n  .adminPaiementMobileMeta div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
